import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Permissions @record={{this.client}} />\n",{ moduleName: "uplisting-frontend/pods/clients/client/access/template.hbs" })